import { BarChart3, CheckCircle, XCircle, Activity, Clock } from 'lucide-react';
import './Stats.css';

function Stats({ stats, tasks }) {
  if (!stats) return (
    <div className="loading-stats">
      Loading stats...
    </div>
  );

  const total = stats.total || 0;
  const active = stats.active || 0;
  const done = stats.done || 0;
  const failed = stats.failed || 0;
  
  const successRate = total > 0 ? Math.round((done / total) * 100) : 0;

  return (
    <div className="stats">
      <h2>Dashboard</h2>

      <div className="stats-grid">
        <div className="stat-card total">
          <div className="stat-icon">
            <BarChart3 size={24} />
          </div>
          <div className="stat-content">
            <span className="stat-value">{total}</span>
            <span className="stat-label">Total Tasks</span>
          </div>
        </div>

        <div className="stat-card active">
          <div className="stat-icon">
            <Activity size={24} />
          </div>
          <div className="stat-content">
            <span className="stat-value">{active}</span>
            <span className="stat-label">Active</span>
          </div>
        </div>

        <div className="stat-card done">
          <div className="stat-icon">
            <CheckCircle size={24} />
          </div>
          <div className="stat-content">
            <span className="stat-value">{done}</span>
            <span className="stat-label">Completed</span>
          </div>
        </div>

        <div className="stat-card failed">
          <div className="stat-icon">
            <XCircle size={24} />
          </div>
          <div className="stat-content">
            <span className="stat-value">{failed}</span>
            <span className="stat-label">Failed</span>
          </div>
        </div>
      </div>

      <div className="stats-sections">
        <div className="stats-section">
          <h3>Success Rate</h3>
          <div className="success-rate">
            <div className="rate-circle" style={{'--rate': `${successRate}%`}}>
              <span>{successRate}%</span>
            </div>
          </div>
        </div>

        {stats.byAgent && Object.keys(stats.byAgent).length > 0 && (
          <div className="stats-section">
            <h3>Tasks by Agent</h3>
            <div className="agent-stats">
              {Object.entries(stats.byAgent).map(([agent, count]) => (
                <div key={agent} className="agent-stat">
                  <span className="agent-name">{agent}</span>
                  <div className="agent-bar">
                    <div 
                      className="agent-fill" 
                      style={{ width: `${(count / total) * 100}%` }}
                    />
                  </div>
                  <span className="agent-count">{count}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {tasks.length > 0 && (
          <div className="stats-section">
            <h3>Recent Activity</h3>
            <div className="recent-tasks">
              {tasks.slice(0, 5).map(task => (
                <div key={task.id} className="recent-task">
                  <span className={`status-dot ${task.status}`} />
                  <span className="recent-desc">{task.description.slice(0, 50)}...</span>
                  <span className="recent-agent">{task.agent}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Stats;
